/* 
 * Export component file to be used on project
*/

import AlertIcon from './AlertIcon.js';
export default AlertIcon;
